/**
 * @file
 */

export function autoHeightAnimate(element, time) {
  const curHeight = element.offsetHeight
  element.style.height = 'auto'
  const autoHeight = element.offsetHeight
  element.style.height = `${curHeight}px`

  setTimeout(() => {
    element.style.transition = `height ${time}ms`
    element.style.height = `${autoHeight}px`
  }, 100)

  element.addEventListener('transitionend', function handler() {
    element.style.height = 'auto'
    element.style.transition = ''
    element.removeEventListener('transitionend', handler)
  })
}

export function autoHeightAnimateClose(element, time, height) {
  const curHeight = element.offsetHeight
  element.style.height = `${curHeight}px`

  setTimeout(() => {
    element.style.transition = `height ${time}ms`
    element.style.height = `${height}px`
  }, 100)

  element.addEventListener('transitionend', function handler() {
    element.style.transition = ''
    element.removeEventListener('transitionend', handler)
  })
}
